import React, { Component } from "react";
import axios from "axios";
import { euro } from "../../../utils/priceFormatter";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Typography,
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Space,
  Select,
  DatePicker,
  message,
} from "antd";

dayjs.extend(customParseFormat);

class PacksDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phones: [],
      internet: [],
      television: [],
      phones_new_total: 0,
    };
    this.formRef = React.createRef();
  }
  componentDidMount() {
    this.getAllPhones();
    this.getAllInternet();
    this.getAllTelevision();
  }
  componentDidUpdate(prevProps) {
    if (this.props.openModal && !prevProps.openModal) {
      if (this.formRef.current) {
        this.formRef.current.resetFields();
        const { pack } = this.props;

        const end_day = pack.end_day
          ? dayjs(pack.end_day, "DD/MM/YYYY")
          : undefined;
        const start_day = pack.start_day
          ? dayjs(pack.start_day, "DD/MM/YYYY")
          : undefined;

        this.formRef.current.setFieldsValue({
          title: pack.title,
          postal_code: pack.postal_code,
          phone_data: pack.phone_data.length > 0 ? pack.phone_data : [],
          internet_select: pack.internet_data && pack.internet_data.id,
          internet_data: pack.internet_data ? pack.internet_data.new_price : "",
          television_select: pack.television_data && pack.television_data.id,
          television_data: pack.television_data
            ? pack.television_data.new_price
            : "",
          valid_range: [start_day, end_day],
        });
      }
    }
    if (this.props.pack.phone_data !== prevProps.pack.phone_data) {
      let phonesNewTotal = 0;
      if (Array.isArray(this.props.pack.phone_data)) {
        this.props.pack.phone_data.forEach((phone, idx) => {
          phonesNewTotal += phone.new_price ? Number(phone.new_price) : 0;
        });
        this.formRef.current.setFieldsValue({
          phone_data:
            this.props.pack.phone_data.length > 0
              ? this.props.pack.phone_data
              : [],
        });
      }
      this.setState(
        {
          phones_new_total: phonesNewTotal,
        },
        () => {
          if (this.formRef.current) {
            this.formRef.current.setFieldsValue({
              phone_new_price: this.state.phones_new_total,
            });
          }
        }
      );
    }
    if (this.props.pack.internet_data !== prevProps.pack.internet_data) {
      this.formRef.current.setFieldsValue({
        internet_data: this.props.pack.internet_data
          ? this.props.pack.internet_data.new_price
          : "",
      });
    }
    if (this.props.pack.television_data !== prevProps.pack.television_data) {
      this.formRef.current.setFieldsValue({
        television_data: this.props.pack.television_data
          ? this.props.pack.television_data.new_price
          : "",
      });
    }
  }
  getAllPhones() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/getActivePhones")
      .then((res) => {
        if (typeof res !== "undefined") {
          this.setState({
            phones: res.data.map((phone) => ({
              value: phone.uuid,
              label: `${phone.title} (${phone.price} €)`,
              props: phone,
            })),
          });
        }
      })
      .catch((error) => message.error(error));
  }
  getAllInternet() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/getActiveInternet")
      .then((res) => {
        if (typeof res !== "undefined") {
          this.setState({
            internet: res.data.map((internet) => ({
              value: internet.uuid,
              label: `${internet.internet_type} | ${internet.title} (${internet.price} €)`,
              props: internet,
            })),
          });
        }
      })
      .catch((error) => message.error(error));
  }
  getAllTelevision() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/getActiveTelevision")
      .then((res) => {
        if (typeof res !== "undefined") {
          this.setState({
            television: res.data.map((television) => ({
              value: television.uuid,
              label: `${television.title} (${television.price} €)`,
              props: television,
            })),
          });
        }
      })
      .catch((error) => message.error(error));
  }
  render() {
    console.log(this.props.pack);
    return (
      <Drawer
        title={
          this.props.isNewService
            ? "Crear Pack Especial"
            : "Editar Pack Especial"
        }
        width={720}
        onClose={() => this.props.handleCancelForm()}
        open={this.props.openModal}
        extra={
          <Space
            style={{
              backgroundColor: "#DEDEDE",
              borderRadius: "25px",
              padding: "8px 32px",
            }}
          >
            {`Precio Total: ${euro.format(this.props.pack.total_price)}`}
          </Space>
        }
      >
        <Form ref={this.formRef} layout="vertical" hideRequiredMark>
          {/* Title */}
          <Col span={24}>
            <Form.Item
              name="title"
              label="Titulo"
              hasFeedback
              validateStatus={this.props.formErrors.title ? "error" : ""}
              help={
                this.props.formErrors.title ? this.props.formErrors.title : ""
              }
            >
              <Input
                name="title"
                style={{ width: "100%" }}
                placeholder="Ingresar el título"
                onChange={(event) => this.props.handleInputChange(event)}
              />
            </Form.Item>
          </Col>
          {/* Postal Code */}
          <Col span={24}>
            <Form.Item
              name="postal_code"
              label="Código Postal"
              hasFeedback
              validateStatus={this.props.formErrors.postal_code ? "error" : ""}
              help={
                this.props.formErrors.postal_code
                  ? this.props.formErrors.postal_code
                  : ""
              }
            >
              <Input
                name="postal_code"
                style={{ width: "100%" }}
                placeholder="Ingresar el título"
                onChange={(event) => this.props.handleInputChange(event)}
              />
            </Form.Item>
          </Col>
          {/* Internet */}
          <Col
            span={24}
            style={{ paddingTop: "8px", borderTop: "1px solid #58C096" }}
          >
            <Form.Item label="Plan de Internet" name="internet_select">
              <Select
                name="internet_select"
                placeholder="Seleccionar Internet"
                allowClear
                options={this.state.internet}
                onChange={(value) => {
                  if (value === undefined) {
                    this.props.handleInputChange(null, "internet", null);
                  } else {
                    const selectedOption = this.state.internet.find(
                      (plan) => plan.props.uuid === value
                    );
                    this.props.handleInputChange(
                      value,
                      "internet",
                      selectedOption.props
                    );
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              name="internet_data"
              label="Nuevo Precio"
              hasFeedback
              validateStatus={
                this.props.formErrors.internet_data ? "error" : ""
              }
              help={
                this.props.formErrors.internet_data
                  ? this.props.formErrors.internet_data
                  : ""
              }
            >
              <Input
                suffix="€"
                style={{ width: "100%" }}
                name="internet_data"
                placeholder="Ingresar nuevo precio."
                disabled={
                  typeof this.props.pack.internet_data.id === "undefined"
                }
                onChange={(event) =>
                  this.props.handleInputChange(event, "internet")
                }
              />
            </Form.Item>
          </Col>
          {/* Phones */}
          <Col
            span={24}
            style={{ paddingTop: "8px", borderTop: "1px solid #58C096" }}
          >
            <Typography.Text style={{ marginBottom: "8px" }}>
              Plan de Móvil
            </Typography.Text>
            <Form.List name="phone_data">
              {(fields, { add, remove }) => (
                <Space direction="vertical" style={{ width: "100%" }}>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      style={{
                        display: "flex",
                        gap: 4,
                        marginBottom: 8,
                        width: "100%",
                      }}
                      align="baseline"
                    >
                      <div
                        style={{
                          flexGrow: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "id"]}
                          style={{ width: "100%", margin: 0 }}
                          rules={[
                            { required: true, message: "Missing first name" },
                          ]}
                        >
                          <Select
                            placeholder="Seleccionar Móvil"
                            style={{ width: "100%" }}
                            options={this.state.phones}
                            initialValue={
                              !this.props.isNewService &&
                              this.props.pack.phone_data
                            }
                            onChange={(value) => {
                              const selectedOption = this.state.phones.find(
                                (plan) => plan.props.uuid === value
                              );
                              this.props.handleInputChange(
                                value,
                                "phone",
                                selectedOption.props,
                                index
                              );
                            }}
                          />
                        </Form.Item>
                      </div>

                      <div
                        style={{
                          flexGrow: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "new_price"]}
                          style={{ width: "100%", margin: 0 }}
                          hasFeedback
                          validateStatus={
                            this.props.formErrors.phone &&
                            this.props.formErrors.phone[index] !== null
                              ? "error"
                              : ""
                          }
                          help={
                            this.props.formErrors.phone &&
                            this.props.formErrors.phone[index] !== null
                              ? this.props.formErrors.phone[index]
                              : ""
                          }
                        >
                          <Input
                            suffix="€"
                            name="new_price"
                            style={{ width: "100%" }}
                            placeholder="Ingresar nuevo precio"
                            disabled={
                              this.props.pack.phone_data[index] &&
                              typeof this.props.pack.phone_data[index].id ===
                                "undefined"
                            }
                            onChange={(event) =>
                              this.props.handleInputChange(
                                event,
                                "phone",
                                null,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </div>
                      <MinusCircleOutlined
                        onClick={() => {
                          this.props.handleRemove(index);
                          remove(name);
                        }}
                      />
                    </div>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => {
                        this.props.handleAddPhone();
                        add();
                      }}
                      block
                      icon={<PlusOutlined />}
                    >
                      Añadir plan de móvil
                    </Button>
                  </Form.Item>
                </Space>
              )}
            </Form.List>
          </Col>
          {/* Television */}
          <Col
            span={24}
            style={{ paddingTop: "8px", borderTop: "1px solid #58C096" }}
          >
            <Form.Item label="Plan de Televisión" name="television_select">
              <Select
                placeholder="Seleccionar Televisión"
                allowClear
                name="television_select"
                options={this.state.television}
                initialValue={
                  !this.props.isNewService &&
                  this.props.pack.television_data &&
                  this.props.pack.television_data.id
                }
                onChange={(value) => {
                  if (value === undefined) {
                    this.props.handleInputChange(null, "television", null);
                  } else {
                    const selectedOption = this.state.television.find(
                      (plan) => plan.props.uuid === value
                    );
                    this.props.handleInputChange(
                      value,
                      "television",
                      selectedOption.props
                    );
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              name="television_data"
              label="Nuevo Precio"
              hasFeedback
              validateStatus={
                this.props.formErrors.television_data ? "error" : ""
              }
              help={
                this.props.formErrors.television_data
                  ? this.props.formErrors.television_data
                  : ""
              }
            >
              <Input
                suffix="€"
                style={{ width: "100%" }}
                name="television_data"
                placeholder="Ingresar nuevo precio"
                disabled={
                  typeof this.props.pack.television_data.id === "undefined"
                }
                onChange={(event) =>
                  this.props.handleInputChange(event, "television")
                }
              />
            </Form.Item>
          </Col>
          {/* Valid Range Picker */}
          <Col
            span={24}
            style={{ paddingTop: "8px", borderTop: "1px solid #58C096" }}
          >
            <Form.Item
              name="valid_range"
              label="Seleccione el periodo de validez"
              hasFeedback
              validateStatus={
                this.props.formErrors.valid_range
                  ? "error"
                  : this.props.formErrors.valid_rangeW
                    ? "warning"
                    : ""
              }
              help={
                this.props.formErrors.valid_range
                  ? this.props.formErrors.valid_range
                  : this.props.formErrors.valid_rangeW
                    ? this.props.formErrors.valid_rangeW
                    : ""
              }
            >
              <DatePicker.RangePicker
                name="valid_range"
                format={"DD/MM/YYYY"}
                placeholder={[
                  "Ingresar fecha de inicio",
                  "Ingresar fecha de fin",
                ]}
                style={{ width: "100%" }}
                onChange={(_, dateString) => {
                  this.props.handleDateChange("valid_range", dateString);
                }}
              />
            </Form.Item>
          </Col>
          {/* Cancel & Submit btn */}
          <Space style={{ paddingTop: "8px" }}>
            <Button onClick={() => this.props.handleCancelForm()}>
              Cancelar
            </Button>
            <Button
              onClick={() =>
                this.props.isNewService
                  ? this.props.handleFormSubmit()
                  : this.props.handleEditForm()
              }
              type="primary"
              disabled={
                (Object.keys(this.props.formErrors).length > 0 &&
                  !this.props.formErrors.hasOwnProperty("phone_data")) ||
                (this.props.formErrors.phone_data &&
                  this.props.formErrors.phone_data.some(
                    (error) => typeof error === "string"
                  )) ||
                this.props.pack.title.length < 1
              }
            >
              {this.props.isNewService ? "Crear Pack" : "Editar Pack"}
            </Button>
          </Space>
        </Form>
      </Drawer>
    );
  }
}

export default PacksDrawer;



// WEBPACK FOOTER //
// ./src/views/Configurator/components/PacksDrawer.jsx